import {DirectiveBinding, ObjectDirective} from "vue";
import {bind, unbind} from "~/ts/vuePlugins/vOnNative";
import {MyTooltip} from "~/core-ui/vue/ui/my-tooltip/MyTooltip";
import {MyTooltipOptionInterface} from "~/core-ui/vue/ui/my-tooltip/MyTooltipOptionInterface";


type Modifiers = "none";


function bindTooltip(el: HTMLElement, binding: DirectiveBinding) {
    let value: MyTooltipOptionInterface = binding.value;
    if (typeof value != "object" || value == null) {
        value = {
            text: value as any as string | undefined
        }
    }

    if (typeof value.text === "string" || value.component) {
        bind("mouseenter", el as any, {
            ...binding,
            modifiers: {} as any,
            value: () => {
                MyTooltip.show(el, value);
            }
        });
        bind("mouseleave", el as any, {
            ...binding,
            modifiers: {} as any,
            value: () => {
                MyTooltip.hide();
            }
        });
    } else {
        MyTooltip.hide();
    }
}

function unbindTooltip(el: HTMLElement) {
    unbind(el as any, "mouseenter");
    unbind(el as any, "mouseleave");
}

export const vMyTooltip: ObjectDirective<any, MyTooltipOptionInterface | string | null, Modifiers> = {
    mounted: (el, binding) => {
        bindTooltip(el, binding);
    },
    beforeUnmount: (el) => {
        unbindTooltip(el);
        MyTooltip.hide();
    },
    updated: (el, binding) => {
        unbindTooltip(el);
        bindTooltip(el, binding);
    }
};

